import { observer } from 'mobx-react'

import type { Action } from 'modules/automations/store/models/Action'

import { AutomationStep } from '../Step'
import { automationSteps } from '../Step/constants'
import { getActionName } from '../actionUtils'

interface Props {
  action: Action
  onClick?: () => void
  withLastSpacer?: boolean
}

const UploadPayslipCoffreFort = ({ action, onClick, withLastSpacer }: Props) => (
  <AutomationStep
    action={action}
    disabled
    onClick={onClick}
    stepType={automationSteps.action}
    withLastSpacer={withLastSpacer}
    title={getActionName(action)}
  />
)

export default observer(UploadPayslipCoffreFort)
